import type { FiltersConfigState } from '@/reducers/filtersConfig';
import type { SearchState } from '@/reducers/search';
import { buildQueryString, mapSearchToPublicURL } from '@/tools/search';
import { mapActualQueryStringToSEO } from '../../helpers/automotive';

const pathParams = ['cb', 'cm', 'ct', 'fl'];
const SEOParams = ['bb', 'bm', 'mt'];

function addIfPresent(
  paramName: string,
  source: Record<string, string>,
  dest: Record<string, string>
): void {
  if (source[paramName]) {
    dest[mapActualQueryStringToSEO(paramName)] = source[paramName];
  }
}

export function getCanonical(
  search: SearchState,
  filtersStoreState: FiltersConfigState,
  origin: string
): string {
  const { path } = mapSearchToPublicURL(search, filtersStoreState);
  let queryObj: Record<string, string> = search.query
    ? { q: search.query }
    : {};

  SEOParams.forEach((param) => addIfPresent(param, search.filters, queryObj));

  if (
    queryObj.q &&
    (Object.keys(queryObj).length > 1 ||
      Object.keys(search.filters).some((filter) => pathParams.includes(filter)))
  ) {
    // We need to reset the query object if we have both the user query and any other param
    // including those that are mapped to the path.
    queryObj = {};
  }

  return `${origin}${path}${buildQueryString(new URLSearchParams(queryObj))}`;
}
